export default "__VITE_ASSET__BkXQmzPY__"